import { render, staticRenderFns } from "./batchUpdateShipment.vue?vue&type=template&id=4f0f1c8e&"
import script from "./batchUpdateShipment.vue?vue&type=script&lang=js&"
export * from "./batchUpdateShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports